import group from "./_group.js";
export default group(function(result, value, key) {
  result[key] = value;
});
